import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type StockChipProps = {
  stock: number;
  size?: 'small' | 'medium';
};

type StockLevel = {
  label: string;
  backgroundColor: string;
};

const LOW_STOCK_THRESHOLD = 100;

const OUT_OF_STOCK_LEVEL: StockLevel = { label: 'Rupture', backgroundColor: '#f42929' };
const LOW_STOCK_LEVEL: StockLevel = { label: 'Faible', backgroundColor: '#9e9e9e' };
const IN_STOCK_LEVEL: StockLevel = { label: 'En stock', backgroundColor: '#4caf50' };

const useStyles = makeStyles(() => ({
  root: (props: { backgroundColor: string }) => ({
    borderRadius: 4,
    backgroundColor: props.backgroundColor,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: 12,
  }),
}));

const getStockLevel = (stock: number): StockLevel => {
  if (stock <= 0) return OUT_OF_STOCK_LEVEL;
  if (stock <= LOW_STOCK_THRESHOLD) return LOW_STOCK_LEVEL;
  return IN_STOCK_LEVEL;
};

export function StockChip({ stock, size = 'small' }: StockChipProps) {
  const { label, backgroundColor } = useMemo(() => getStockLevel(stock), [stock]);
  const classes = useStyles({ backgroundColor });

  return <Chip className={classes.root} size={size} label={`${label} ${stock}`} />;
}
